import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-search',
  templateUrl: './icon-search.component.html',
  styleUrls: ['./icon-search.component.scss']
})
export class IconSearchComponent implements OnInit {

  @Input() cssClass = '';

  constructor() { }

  ngOnInit() {
  }

}
